import * as React from "react";
const SvgTempAmbient20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M9.179 1h1.636v4.09H9.179V1Zm4.907 9a4.09 4.09 0 1 1-8.18.001 4.09 4.09 0 0 1 8.18-.001Zm-3.271 9v-4.09H9.179V19h1.636Zm8.179-9.818L19 10.818l-4.09.016-.006-1.636 4.09-.016ZM5.096 10.873l-.007-1.637L1 9.252l.006 1.636 4.09-.015Zm11.16-7.39 1.072 1.236L14.239 7.4l-1.072-1.236 3.089-2.681ZM6.827 13.836 5.755 12.6l-3.089 2.68 1.072 1.236 3.089-2.681Zm10.122 1.935-1.155 1.16-2.897-2.887 1.154-1.16 2.898 2.887ZM5.943 7.116l1.154-1.16L4.199 3.07 3.045 4.23l2.898 2.887Z"
    })
  );
export default SvgTempAmbient20Px;
